import { FunctionComponent } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { routes } from './routes';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
const router = sentryCreateBrowserRouter(routes);

const Router: FunctionComponent = () => <RouterProvider router={router} />;

export default Router;
